import React from 'react'
import { t } from '@/i18n'

interface Props {
  value?: boolean
}

const BooleanRow: React.FC<Props> = ({ value }) => {
  if (value) {
    return <b>{t('True')}</b>
  }
  return <b>{t('False')}</b>
}

export default BooleanRow
